import React, {useEffect, useRef, useState, useMemo} from "react";
import styled from "styled-components";
import {Swiper, SwiperSlide} from "swiper/react";
import {hover, regular, title, white} from '../../styles/globalStyleVars';
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/css/scrollbar';
import {Autoplay, Navigation, Pagination} from "swiper";
import {Col, Container, Row} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import {Img} from "../Img";
import {ImgP} from "../ImgP";
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import reactHtmlParser from "react-html-parser";

const Banner = ({data, offset, feature_data,scrollContainerRef}) => {

    const swiperRef = useRef(null);
    const swiperRefTwo = useRef(null);
    const location = useLocation();


    // handle slider progress
    const handleProgress = (swiper) => {
        let interleaveOffset = 0.5;
        for (let i = 0; i < swiper.slides.length; i++) {
            let slideProgress = swiper.slides[i].progress;
            let innerOffset = swiper.width * interleaveOffset;
            let innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(".global-image").style.transform =
                "translate3d(" + innerTranslate + "px, 0, 0)";
        }

    };

    // hand touch move not required this slider
    const handleTouchStart = (swiper) => {
        for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
        }
    };


    // handle image transition on change
    const handleSetTransition = (swiper, speed) => {
        for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = `${speed}ms`;
            swiper.slides[i]
                .querySelector(".global-image")
                .style.transition = `${speed}ms`;

        }
    };


    // handle pagination
    let pagination_title = ['Financial freedom at the palm of your hands', 'Investing in growth to open new big opportunities', 'Financial freedom at the palm of your hands', 'Investing in growth to open new big opportunities']
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<div class="' + className + '"><span>' + pagination_title[index] + "</span></div>";
        },
    };
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);


    const handleSlideChange = (event) => {

        const newActiveSlideIndex = event.realIndex;
        setActiveSlideIndex(newActiveSlideIndex);
        if (swiperRefTwo.current) {
            swiperRefTwo.current.swiper.slideTo(newActiveSlideIndex);
        }
    };

    const handleButtonClickPagination = (index) => {
        if (swiperRef.current) {
            setActiveSlideIndex(index);
            swiperRef.current.swiper.slideToLoop(index);
        }
    };


    useEffect(() => {
        const swiper = swiperRef.current;

        const autoplayDelay = 5000; // Delay in milliseconds before autoplaying

        const autoplayTimeout = setTimeout(() => {
            if (swiper && swiper.autoplay) {
                swiper.autoplay.start();
            }
        }, autoplayDelay);

        return () => {
            clearTimeout(autoplayTimeout);
        };
    }, []);


// ...

    // ...

    useEffect(() => {
        document.fonts.ready.then(() => {
            gsap.utils.toArray('.split-up-banner').forEach((item, i) => {
                const parentSplit = new SplitText(item, {
                    linesClass: "split-parent"
                });

                const childSplit = new SplitText(item, {
                    type: "lines, chars",
                    linesClass: "split-child"
                });

                gsap.from(parentSplit.lines, {
                    duration: 1,
                    delay: .8,
                    yPercent: 100,
                    stagger: 0.2,
                    opacity: 0,
                    ease: "power2.inOut",
                    scrollTrigger: {
                        trigger: item,
                        toggleActions: "restart none none reset",
                        start: "top 95%",
                        scroller: scrollContainerRef.current.view, // Use rc-scrollbar's view property
                    }
                });
            });

            gsap.utils.toArray('.split-up-banner-des').forEach((item, i) => {
                const parentSplit = new SplitText(item, {
                    linesClass: "split-parent"
                });

                const childSplit = new SplitText(item, {
                    type: "lines, chars",
                    linesClass: "split-child"
                });

                gsap.from(parentSplit.lines, {
                    duration: 0.8,
                    delay: 1,
                    yPercent: 100,
                    stagger: 0.2,
                    opacity: 0,
                    ease: "power2.inOut",
                    scrollTrigger: {
                        trigger: item,
                        toggleActions: "restart none none reset",
                        start: "top 95%",
                    }
                });
            });
        }, [location.pathname, activeSlideIndex]); // Include activeSlideIndex as a dependency
    }, [location.pathname, activeSlideIndex]); // Wrap the entire useEffect in another dependency array

// ...


// ...


    return (
        <>
            <StyledBanner offset={offset} className={'home-banner'}>
                {
                    data?.list && data?.list?.length>0 ?
                        <Swiper
                            ref={swiperRef}
                            spaceBetween={0}
                            loop={true}
                            // autoplay
                            speed='2500'
                            onSlideChange={handleSlideChange}
                            onProgress={handleProgress}
                            touchStart={handleTouchStart}
                            onSetTransition={handleSetTransition}
                            grabCursor={false}
                            lazy={true}
                            watchSlidesProgress={true}
                            mousewheelControl={true}
                            keyboardControl={true}
                            navigation={{
                                prevEl: '#banner-prev',
                                nextEl: '#banner-next',
                            }}
                            pagination={pagination}
                            modules={[Autoplay, Pagination, Navigation]}
                            sName="mySwiper main-swiper"
                            autoplay={true}
                        >
                            {
                                data?.list && data?.list?.length>0 &&
                                data?.list?.map((element)=>{
                                    return(
                                        <SwiperSlide>
                                            <div className="slide-inner">
                                                {
                                                    window.innerWidth > 767 ?

                                                        <div className="desktop">
                                                            <ImgP
                                                                 src={element?.image}/>
                                                        </div>

                                                        :

                                                        <div className="mobile">
                                                            <Img
                                                                src={element?.mimage ? element?.mimage : element?.image}/>
                                                        </div>

                                                }
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            <div className="slide-inner__info">
                                                                <h1 className={'split-up-banner'}>{reactHtmlParser(element?.subtitle)}</h1>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper> : ''
                }


                <div className="swipper-navigation-slider-custom">
                    {
                        data?.list && data?.list?.length>0 ?
                            <Swiper
                                ref={swiperRefTwo}
                                speed='1000'
                                slidesPerView={4}
                                spaceBetween={30}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 30,

                                    },
                                    768: {
                                        slidesPerView: 1,
                                        spaceBetween: 30,

                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        spaceBetween: 30,
                                    },
                                }}
                                modules={[Autoplay, Pagination, Navigation]}
                                className="mySwiperNext"
                            >
                                {
                                    data?.list && data?.list?.length>0 &&
                                    data?.list?.map((element,index)=>{
                                        return(
                                            <SwiperSlide key={index}>
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            {
                                                                element?.title &&
                                                                <div
                                                                    className={`slide-inner-item ${activeSlideIndex === index ? 'active' : ''}`}
                                                                    onClick={() => handleButtonClickPagination(index)}>
                                                                    {element?.title && <h6>{element?.title}</h6>}
                                                                </div>
                                                            }

                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper> : ''
                    }

                </div>


                {/*next prev navigation*/}
                <div className="navigation">
                    <Container>
                        <Row>
                            <Col>
                                <ul>
                                    <li id={'banner-next'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                             viewBox="0 0 44 44">
                                            <g id="Next" transform="translate(16429 -2014)">
                                                <g id="Rectangle_492" data-name="Rectangle 492"
                                                   transform="translate(-16429 2014)" fill="none" stroke="#fff"
                                                   stroke-width="1" opacity="0.5">
                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                          fill="none"/>
                                                </g>
                                                <g id="Group_4824" data-name="Group 4824"
                                                   transform="translate(-17065.5 434.5)">
                                                    <g id="Group_4823" data-name="Group 4823"
                                                       transform="translate(11 4)">
                                                        <line id="Line_9" data-name="Line 9" x2="5" y2="5"
                                                              transform="translate(647.5 1592.5)" fill="none"
                                                              stroke="#fff"
                                                              strokeLinecap="round" stroke-width="1"/>
                                                        <line id="Line_10" data-name="Line 10" x1="5" y2="5"
                                                              transform="translate(647.5 1597.5)" fill="none"
                                                              stroke="#fff"
                                                              strokeLinecap="round" stroke-width="1"/>
                                                    </g>
                                                    <line id="Line_11" data-name="Line 11" x2="10"
                                                          transform="translate(653.5 1601.5)" fill="none"
                                                          stroke="#fff"
                                                          strokeLinecap="round" stroke-width="1"/>
                                                </g>
                                                <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                   transform="translate(-16429 2058) rotate(-90)" fill="none"
                                                   stroke="#fff"
                                                   stroke-width="1" strokeDasharray="0" opacity="0">
                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                          fill="none"/>
                                                </g>
                                            </g>
                                        </svg>

                                    </li>
                                    <li id={'banner-prev'}>
                                        <svg id="Prev" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                             viewBox="0 0 44 44">
                                            <g id="Rectangle_492" data-name="Rectangle 492" fill="none"
                                               stroke="#fff"
                                               stroke-width="1" opacity="0.5">
                                                <rect width="44" height="44" rx="22" stroke="none"/>
                                                <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                            </g>
                                            <g id="Group_4824" data-name="Group 4824" transform="translate(17 17)">
                                                <g id="Group_4823" data-name="Group 4823">
                                                    <line id="Line_9" data-name="Line 9" x1="5" y2="5" fill="none"
                                                          stroke="#fff" strokeLinecap="round" stroke-width="1"/>
                                                    <line id="Line_10" data-name="Line 10" x2="5" y2="5"
                                                          transform="translate(0 5)" fill="none" stroke="#fff"
                                                          strokeLinecap="round" stroke-width="1"/>
                                                </g>
                                                <line id="Line_11" data-name="Line 11" x1="10"
                                                      transform="translate(0 5)"
                                                      fill="none" stroke="#fff" strokeLinecap="round"
                                                      stroke-width="1"/>
                                            </g>
                                            <g id="Rectangle_5661" data-name="Rectangle 5661"
                                               transform="translate(0 44) rotate(-90)" fill="none" stroke="#fff"
                                               stroke-width="1" strokeDasharray="1 140" opacity="0">
                                                <rect width="44" height="44" rx="22" stroke="none"/>
                                                <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                            </g>
                                        </svg>


                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </StyledBanner>
        </>
    );
};

const StyledBanner = styled.section`
  height: 100vh;
  position: relative;
  opacity: 1 !important;

  .swiper-button-prev, .swiper-button-next, .swiper-pagination, .mobile {
    display: none;
  }

  .swiper-slide {
    overflow: hidden;
  }

  .swiper-pagination {
    display: none;
  }

  .swiper-button-disabled {
    opacity: 0.5 !important;
  }

  .global-image {
    transition: clipPath .8s cubic-bezier(.29, .73, .45, 1), border-color 3.6s linear, -webkit-clipPath .8s cubic-bezier(.29, .73, .45, 1);
    will-change: clipPath;
    overflow: hidden;
    -webkit-clipPath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    clipPath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }

  .swiper-slide-active, .swiper-slide-visible {
    .global-image {
      clipPath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    }

    .slide-inner {

      img {
        height: 100vh !important;
      }
    }
  }

  //custom navigation
  .swipper-navigation-slider-custom {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40px;
    min-height: 75px;
    text-align: left;
    margin: 0 auto;
    padding-left: ${props => props.offset ? props.offset : '115'}px;
    padding-right: ${props => props.offset ? props.offset : '90'}px;
    justify-content: space-between;
    gap: 15px;
    flex-direction: row;

    .slide-inner-item {
      width: 100%;
      position: relative;
      background: transparent !important;
      padding: 20px 0px 0;
      cursor: pointer;

      @media (min-width: 1536px) {
        padding-right: 15px;
      }

      span {
        font-size: 20px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 28px;
      }
      h6{
        color: ${white};
      }

      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 4px;
        background: ${hover};
        width: 0;
        transition: 1s all cubic-bezier(.25, .74, .22, .99);
        opacity: 0;
      }

      &:hover {
        // span {
          //   color: ${hover}
        // }
        &:after {
          width: 100%;
          opacity: 1;
        }

      }

      &:before {
        content: '';
        background: transparent !important;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 99;
      }

      &.active {


        &:after {
          width: 100%;
          opacity: 1;
        }

      }

    }
  }

  .slide-inner {
    position: relative;
    height: 100vh;
    .container{
      .col{
        padding-left: 15px !important; ;
        padding-right: 15px !important; ;
      }
    }
    

    .container {
      position: absolute;
      left: 0;
      right: 0;
      top: calc(50% + 5vh);
      transform: translateY(-50%);
      z-index: 2;
    }

    .global-image {
      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 1;
        background: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
      }
    }

    &__info {
      position: relative;
      overflow: hidden;
      //transform: translateX(50%);
      //transition: all 2s cubic-bezier(.25, .74, .22, .99);
      //transition-delay: 1.2s;
      //opacity: 1;
      @media (min-width: 1024px) {
        width: 70%;
      }

      h1 {
       
        color: ${white};
        position: relative;
        margin-bottom: 40px;
        
      }

      .dc-btn {
        position: relative;
        //transform: translateY(400px);
        //transition-delay: 1.2s;
        //transform: translateX(50%);

        //transition: 2.4s all cubic-bezier(.25, .74, .22, .99);
        //opacity: 0;

      }
    }
  }


  //navigation
  .navigation {
    position: absolute;
    right: ${props => props.offset ? props.offset : '115'}px;
    top: calc(50% + 5vh);
    transform: translateY(-50%);
    display: inline-block;
    z-index: 1;

    ul {
      display: flex;
      flex-direction: column;

      li {
        cursor: pointer;

        &:first-child {
          margin-bottom: 20px;
          margin-right: 0;
        }

        svg {
          path, #Rectangle_5661 {
            //transition: strokeDasharray 0.3s ease-in-out;
            transition: all 1s cubic-bezier(.25, .74, .22, .99);
          }
        }


        &:hover {
          svg {
            #Rectangle_5661 {
              opacity: 1;

              stroke-dasharray: 140px;
            }

            path {
              stroke: ${hover};
            }
          }
        }
      }
    }
  }


  //responsive
  @media (min-width: 1550px) {
    .slide-inner {
      &__info {
        position: relative;
        overflow: hidden;

        h2 {
          font-size: 80px;
          line-height: 100px;
        }

        .dc-btn {
          a {
            font-size: 22px;
            line-height: 33px;
          }
        }
      }
    }

    .swipper-navigation-slider-custom {
      bottom: 100px;
    }

    .feature-box-container {
      bottom: -150px;
    }

    .feature-box-container {
      .single-item-wrapper {
        min-height: 300px;

        .content {
          min-height: 250px;
        }
      }
    }
  }
  @media (max-width: 992px) {
    .swipper-navigation-slider-custom {
      bottom: 150px;

    }
  }

  @media (max-width: 992px) and (min-width: 768px) {
    height: 100vh;
    .swipper-navigation-slider-custom {
      bottom: 60px;

      .swiper-initialized {
        padding-right: 30%;
      }
    }

    .slide-inner {
      height: 100vh;

      .container {
        top: 45%;
      }
    }

    .feature-box-container {
      display: none;
      position: relative;
      left: 0;
      right: 0;
      bottom: 200px;
      z-index: 999;
      width: calc(100% - 30px);
      margin: 0 auto;


      .single-item-wrapper a .content {
        align-items: flex-start;
      }

      .feature-box-container_item:last-child {
        order: 1;
        flex: 0 0 100%;
        max-width: 100%;
      }

      .feature-box-container_item:first-child {
        order: 2;
        flex: 0 0 100%;
        max-width: 100%;

        .single-item-wrapper {
          border-right: none;
          border-bottom: 1px solid rgba(198, 198, 198, 0.5);
        }

      }

      .feature-box-container_item:nth-of-type(2) {
        order: 3;
        flex: 0 0 50%;
        max-width: 50%;
      }

      .feature-box-container_item:nth-of-type(3) {
        order: 4;
        flex: 0 0 50%;
        max-width: 50%;

        .single-item-wrapper {
          border-right: none;

        }

      }
    }


  }
  @media (max-width: 767px) {
    height: 90vh;
    .desktop {
      display: none;
    }

    .mobile {
      display: block;
    }

    .slide-inner {
      height: 100vh;

      .container {
        top: unset;
        transform: unset;
        bottom: 40%;
        .col{
          padding-left: 15px !important; ;
        }
      }

      &__info {
        position: relative;
        overflow: hidden;


        h2 {
          font-size: 40px;
          line-height: 48px;
        }

        .dc-btn {
          margin-top: 30px;
        }
      }
    }

    .swipper-navigation-slider-custom {
      padding-left: 15px !important;
      padding-right: 15px !important;
      bottom: 30px;
      
      .col{
        padding-left: 0px !important;
      }

      .swiper-initialized {
        padding-right: 30%;
      }
    }


    .scrollTo {
      left: 15px;
      right: unset;
      display: inline-block;
      bottom: 20px;
      transform: translateX(0);
    }

    .navigation {
      display: none;
    }


    .feature-box-container {

      display: none;
      position: relative;
      bottom: 150px;

      .feature-box-container_item {
        &:first-child {
          order: 2;
        }

        &:nth-of-type(2) {
          order: 3;
        }

        &:nth-of-type(3) {
          order: 4;
        }

        &:last-child {
          order: 1;

          .content {
          }
        }
      }

      .single-item-wrapper {
        border-right: none;
        border-bottom: 1px solid rgba(198, 198, 198, 0.5);

        .content {
          align-items: flex-start !important;
        }

        &.last {
          border: none;

          .content {
            align-items: center !important;
          }
        }


      }

      .container {
        padding: 0;
      }
    }
  }





`;

export default React.memo(Banner);
